module.exports = __webpack_public_path__ + "static/media/palafis.7e840888.png";